/* RESPONSIBLE TEAM: team-inbox-experience */
import { isPresent } from '@ember/utils';

export interface PhoneNumberWireFormat {
  readonly id: number;
  readonly name?: string;
  readonly number: string;
  readonly country_code: string;
  readonly phone_type: number;
  readonly verification_status?: number;
}

export class PhoneNumber {
  readonly id: number;
  readonly name?: string;
  readonly number: string;
  readonly countryCode: string;
  readonly phoneType: number;
  readonly verificationStatus?: number;

  constructor(inputs: {
    id: number;
    name?: string;
    number: string;
    countryCode: string;
    phoneType: number;
    verificationStatus?: number;
  }) {
    this.id = inputs.id;
    this.name = inputs.name;
    this.number = inputs.number;
    this.countryCode = inputs.countryCode;
    this.phoneType = inputs.phoneType;
    this.verificationStatus = inputs.verificationStatus;
  }

  get displayString(): string {
    if (isPresent(this.name)) {
      return `${this.name} (${this.number})`;
    }
    return this.number;
  }

  get compactDisplayString(): string {
    return `${this.countryCode} ${this.number}`;
  }

  static deserialize(json: PhoneNumberWireFormat) {
    return new PhoneNumber({
      id: Number(json.id),
      name: json.name,
      number: json.number,
      countryCode: json.country_code,
      phoneType: json.phone_type,
      verificationStatus: json.verification_status,
    });
  }
}
